var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticStyle:{"width":"285px","height":"230px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }